export const hasActiveFilters = (filters) => {
  const DEFAULT_PRICE = { min: 0, max: 5000 };

  const isNonEmptyArray = (v) =>
    Array.isArray(v) && v.some((x) => x && x !== "");

  const isNonEmptyString = (v) => typeof v === "string" && v.trim().length > 0;

  const hasActivePrice =
    filters.price &&
    (filters.price.min !== DEFAULT_PRICE.min ||
      filters.price.max !== DEFAULT_PRICE.max);

  return (
    isNonEmptyArray(filters.sizes) ||
    isNonEmptyArray(filters.colors) ||
    isNonEmptyArray(filters.tags) ||
    isNonEmptyArray(filters.types) ||
    hasActivePrice ||
    isNonEmptyString(filters.search) ||
    isNonEmptyString(filters.searchTerm)
  );
};
